import { notificacaoErro } from "../app/notificacao";

async function fetchAtualizaCategoria(nome, token, categoriaId) {
  const url = new URL(process.env.REACT_APP_API_URL + "/categoria/" + categoriaId);
  const init = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ descricao: nome }),
  };

  const fet = await fetch(url, init);

  switch (fet.status) {
    case 200:
      return { success: true, status: fet.status, data: await fet.json() };
    case 404:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro ao atualizar a categoria."),
      };
    default:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro inesperado ao atualizar a categoria."),
      };
  }
}

const atualizaCategoria = { fetchAtualizaCategoria };

export default atualizaCategoria;
